import { render, staticRenderFns } from "./Arbeitszeit.vue?vue&type=template&id=52805d12&"
import script from "./Arbeitszeit.vue?vue&type=script&lang=js&"
export * from "./Arbeitszeit.vue?vue&type=script&lang=js&"
import style0 from "./Arbeitszeit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports